import { Layout } from "antd";
import styled from "styled-components";

export const DataGenerationContainer = styled(Layout)`
  /* width: 100%; */
  padding: 10px 25px;
  box-sizing: border-box;
  margin: 20px 20px;

  .heading {
    background-color: white;
    padding-top: 10px;

    padding-left: 10px;
    padding-right: 10px;
    border-radius: 4px;
    color: #2f4f4f;

    h4 {
      color: #2f4f4f !important;
    }
  }
`;

export const ServersWrapper = styled.div`
  display: flex;
  width: 100%;
  display: flex;
  padding: 30px 20px;
  border-radius: 8px;
  color: #18425c;
  margin-bottom: 20px;
  justify-content: space-around;
  background-color: #ffffffa1;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
`;

export const TableWrapper = styled.div``;
